module.exports = __webpack_public_path__ + "images/color-fun-5-68cd0d9e7f14d70faf6eae0f8deb8bb3.jpg";